<template>
  <div class="space-y-1">
    <p class="h3-title pb-4">【A】数字化基础维度</p>
    <p class="font-heiti">A1 设备系统</p>
    <p>{{info.p_2_1_a_0}}</p>
    <p class="text-bold pt-4">——A11 网络建设</p>
    <p>{{info.p_2_1_a_1}}</p>
    <p>{{info.p_2_1_a_2}}</p>
    <p class="text-bold pt-4">——A12 设备数字化</p>
    <p>{{info.p_2_1_a_3}}</p>
    <p>{{info.p_2_1_a_4}}</p>
    <p>生产设备总数量 {{info.answerArr[1].otherAns.all * 1 || 0}} 台，实现数字化的生产设备数量 {{info.answerArr[1].otherAns.digit * 1 || 0}} 台。</p>
    <p class="text-bold pt-4">——A13 设备联网</p>
    <p>{{info.p_2_1_a_5}}</p>
    <p>{{info.p_2_1_a_6}}</p>
    <p>生产设备总数量 {{info.answerArr[1].otherAns.all * 1 || 0}} 台，实现联网的生产设备数量 {{info.answerArr[1].otherAns.online * 1 || 0}} 台。</p>
    <p class="font-heiti pt-4">A2 数据采集</p>
    <p>{{info.p_2_1_b_1}}</p>
    <p>{{info.p_2_1_b_2}}</p>
    <p class="font-heiti pt-4">A3 信息系统</p>
    <p>{{info.p_2_1_c_1}}</p>
    <p>{{info.p_2_1_c_2}}</p>
  </div>
</template>

<script>

// 数字化基础维度1
export default {
  props: ['info']
}
</script>
